import React, { memo } from 'react'
import tw from 'twin.macro'
import { Skeleton } from './Skeleton'

interface Props {
  /** Number of text lines; the last one is drawn shorter, as a paragraph's last line is. */
  lines?: number
  dataTestId?: string
}

/**
 * The loading shape of a short run of text — a status line, a card's body — where a
 * "Loading…" sentence used to sit.
 */
const TextSkeletonComponent = ({ lines = 2, dataTestId }: Props) => {
  return (
    <div
      role="status"
      aria-label="Loading"
      css={tw`flex flex-col gap-2`}
      {...(dataTestId ? { 'data-testid': dataTestId } : {})}
    >
      {Array.from({ length: lines }).map((_, index) => {
        const isLast = index === lines - 1

        return <Skeleton key={index} className={isLast ? tw`h-4 w-2/3` : tw`h-4 w-full`} />
      })}
    </div>
  )
}

export const TextSkeleton = memo(TextSkeletonComponent)
